import React from 'react';
import {Box, Card, CardContent, Stack, Typography} from "@mui/material";
import {GooglePlacesAutocomplete} from "../../../../../components/address-autocomplete";
import {LoadingButton} from "@mui/lab";

interface AddressType {
    address : string,
    placeId : string
}

interface Props {
    address : AddressType;
    isLoading : boolean;
    handleSearch:()=>void;
    setAddress:(address : AddressType)=>void;
    disabled : boolean
}

export const ReportSearch: React.FC<Props> = ({address,isLoading,handleSearch,disabled,setAddress}) => {
    return (
        <Stack margin={'auto'}>
            <Card>
                <CardContent sx={{padding:5}}>
                    <Stack>
                        <Typography fontWeight={500} fontSize={14} sx={{mb:{xs:4,md:10}}}>
                            Enter An Address To Check Crime Statistics And Registered Sex Offender Information Nearby.
                        </Typography>
                        <Box sx={{padding:3,mb:{xs:4,md:10}}}>
                            <GooglePlacesAutocomplete  initialValue={{description:address.address,place_id:address.placeId}} onAddressSelect={(address,placeId)=>{setAddress({address,placeId})}}/>
                        </Box>
                        <LoadingButton
                            sx={{margin:'auto',padding:"0.6rem 1rem 0.6rem 1rem"}}
                            variant="contained"
                            loading={isLoading}
                            onClick={handleSearch}
                            disabled={disabled}
                        >
                            Generate Report
                        </LoadingButton>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    )
}